<template>
  <div class="loader-block">
    <span class="loader"></span>
  </div>
</template>

<style scoped>
.loader-block{
  z-index: 11;
  position: fixed;
  top:0;
  left:0;
  width:100%;
  height:100%;
  display: flex;
  justify-content: center;
  align-items: center;
  backdrop-filter: blur(10px);
}
.loader {
  box-sizing: border-box;
  position: fixed;
  width: 48px;
  height: 48px;
  animation: spin 1s linear infinite;
}
.loader:after,
.loader:before {
  content: "";
  width: 24px;
  height: 24px;
  position: absolute;
  border-radius: 50%;
  background: var(--factstory);
  animation: spin 1s linear infinite;
  transform-origin: 0px 100%;
}
.loader:before {
  transform-origin: 0 50%;
  background: var(--blue-marine);
}
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
